<svg
  width="33"
  height="34"
  viewBox="0 0 33 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_3_250)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.25 17C31.25 25.1462 24.6462 31.75 16.5 31.75C8.3538 31.75 1.75 25.1462 1.75 17C1.75 8.8538 8.3538 2.25 16.5 2.25C24.6462 2.25 31.25 8.8538 31.25 17ZM16.5 33.5C25.6127 33.5 33 26.1127 33 17C33 7.8873 25.6127 0.5 16.5 0.5C7.3873 0.5 0 7.8873 0 17C0 26.1127 7.3873 33.5 16.5 33.5Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_3_250">
      <rect width="33" height="33" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
